import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import './ContactUs.css';

function ContactUs() {
  return (
    <div className="contact-us-page">
      <Header />

      <main className="contact-us-main">
        <div className="contact-us-container">
          <h1>Contact Us</h1>
          
          {/* About Section */}
          <section className="contact-section">
            <h2>About Rec-Chord</h2>
            <p>
              Rec-Chord: A portmanteau of "record" and "recreational," symbolizing the creation 
              of professional-quality transcripts with a recreational time commitment. "Chord" 
              also references the key combinations used in stenography.
            </p>
            <p className="tagline">Your Voice, Perfectly Penned. No Experience Necessary.</p>
          </section>

          {/* Product Section */}
          <section className="contact-section">
            <h2>Product</h2>
            <ul>
              <li><Link to="/plans-and-payment">Pricing</Link></li>
              <li><Link to="/dashboard">Dashboard</Link></li>
            </ul>
          </section>

          {/* Contact Section */}
          <section className="contact-section">
            <h2>Contact</h2>
            <p>
              <a href="mailto:support@raindragon.ai">support@raindragon.ai</a>
            </p>
          </section>

          {/* Copyright */}
          <div className="contact-copyright">
            <p>© 2025 Rec-Chord. All rights reserved.</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ContactUs;
